import { IOBOAccount } from '../models/obo-account';
import { IResult } from '../models/result-models';
import { apiGet, apiPost } from './api-utils';
import { IOBOOrderCertificates } from '..//models/obo-orderCertificates';

const baseUrl =
    process.env.REACT_APP_API_URL + '/v1/orderOnBehalfOf/SearchAccount/';

export const getOBOAccount = async (
    accountNumber: string
): Promise<IResult<IOBOAccount>> => {
    const result = await apiGet<IOBOAccount>(`${baseUrl}${accountNumber}`);
    return result;
};

const baseUrl2 =
    process.env.REACT_APP_API_URL +
    '/v1/orderOnBehalfOf/PlaceCertificatesOrder';

export const submitCertificatesOrder = async (
    request: IOBOOrderCertificates
): Promise<IResult<boolean>> => {
    const result = await apiPost<IOBOOrderCertificates, boolean>(
        `${baseUrl2}`,
        request
    );
    return result;
};
